// src/redux/actions/auth.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import API from "../../service/Api";

// signup action
export const createSignUp = createAsyncThunk(
  "auth/createSignUp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.post("signup", data);
      if (response?.data?.status && response.data.status !== 200) {
        return rejectWithValue(response.data.message || "Signup failed");
      }
      return response.data;
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message || error?.message || "Signup failed";
      return rejectWithValue(serverMsg);
    }
  }
);

// social signup action
export const socialSignup = createAsyncThunk(
  "auth/socialSignup",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.post("social_Signup", data);
      return response.data; // pass backend response to slice
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Social signup failed";

      toast.error(serverMsg);
      return rejectWithValue(serverMsg);
    }
  }
);

// verify otp action
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ id, otp }, { rejectWithValue }) => {
    try {
      const response = await API.post("/verify_otp", { id, otp });
      return response.data;
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "OTP verification failed";
      return rejectWithValue(serverMsg);
    }
  }
);

// resend otp
export const resendOtp = createAsyncThunk(
  "auth/resendOtp",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await API.post("/resend_otp", { id });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || "Failed to resend OTP";
      return rejectWithValue(msg);
    }
  }
);

// forgot password action (NEW)
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (payload, { rejectWithValue }) => {
    try {
      // payload = { email, reset_url }

      const response = await API.post("/Forgot_password", payload);

      return response.data;
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Failed to initiate password reset";

      return rejectWithValue(serverMsg);
    }
  }
);

// reset password action (NEW)
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (data, { rejectWithValue }) => {
    try {
      // The data object should contain: { new_password, confirm_password, token_or_identifier }
      const response = await API.post("/Reset_password", data);
      // toast.success(response.data.message || "Password successfully reset!");
      return response.data;
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Failed to reset password";
      toast.error(
        typeof serverMsg === "string"
          ? serverMsg
          : "Server error (check console)"
      );
      return rejectWithValue(serverMsg);
    }
  }
);

// login action
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await API.post("/login", credentials);
      return response.data;
    } catch (error) {
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Login failed";
      toast.error(serverMsg);
      return rejectWithValue(serverMsg);
    }
  }
);

// logout action
export const logout = createAsyncThunk("logout", async () => {
  const response = await API.get("auth/logout");
  return response.data;
});
